import { NgModule, Injector } from "@angular/core";
import { InjectorInstance } from "./core/injector-instance";

@NgModule()
export class InjectorModule {
  constructor(private injector: Injector) {
    InjectorInstance.setInstance(this.injector);
  }
}
